/* global Raven */
'use strict';
import Config from 'config';

if (Config.env == 'production') {
  Raven.config(
    'https://b0c6a263c8a84037ad75d8f5cc039021@sentry.io/200665'
  ).install();
}

export default Raven;
